import { createSlice } from '@reduxjs/toolkit';

const alertsSlice = createSlice({
  name: 'alerts',
  initialState: {
    pending: [],
    sosEvents: [],
  },
  reducers: {
    alertReceived: (state, action) => {
      state.pending.unshift(action.payload);
    },
    alertRemoved: (state, action) => {
      state.pending = state.pending.filter((a) => a.alert_id !== action.payload);
    },
    sosReceived: (state, action) => {
      state.sosEvents.unshift(action.payload);
    },
  },
});

export const { alertReceived, alertRemoved, sosReceived } = alertsSlice.actions;
export default alertsSlice.reducer;
